export { default } from './FinanciamentoDeMotos25';
